/**
 * Returns true or false if the user is granted for the permission.
 * @param permissionName
 * @returns {*}
 */
// eslint-disable-next-line no-undef
export const isGranted = (permissionName) => abp.auth.isGranted(permissionName);
